import axios from 'axios'

export default {
  actions: {
    async createInquiry ({ commit }, query) {
      await axios.post('/api/inquiries', {
        ...query
      })
    }
  },
  mutations: {},
  state: {},
  getters: {}
}
